"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentBonusToOpen = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Lockr = __importStar(require("lockr"));
var react_1 = require("react");
var useCurrentBonusToOpen = function () {
    var balance = (0, swr_hooks_1.useBalance)().data;
    var data = (0, swr_hooks_1.useBonuses)(balance === null || balance === void 0 ? void 0 : balance.currency).data;
    var popupWasShownData = (0, react_1.useMemo)(function () {
        if (typeof window !== 'undefined')
            return Lockr.get(apps_shared_1.POPUP_CONSTANTS.CASH_BONUS) || {};
        return {};
    }, []);
    return (0, react_1.useMemo)(function () {
        return data === null || data === void 0 ? void 0 : data.find(function (bonus) { return bonus.id && !(popupWasShownData === null || popupWasShownData === void 0 ? void 0 : popupWasShownData[bonus.id]); });
    }, [data, popupWasShownData]);
};
exports.useCurrentBonusToOpen = useCurrentBonusToOpen;
